import { apiSlice } from './apiSlice';

export interface ChangePasswordParams {
  oldPassword: string;
  newPassword: string;
}

export const adminApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    changePassword: builder.mutation<{ status: string }, ChangePasswordParams>({
      query: (credentials) => ({
        url: '/admin/change-password',
        method: 'POST',
        body: credentials,
      }),
      invalidatesTags: ['Admin'],
    }),
  }),
});

export const { useChangePasswordMutation } = adminApi;
